import { render, staticRenderFns } from "./VirtualReadingForm.vue?vue&type=template&id=6b7d9a21&scoped=true&"
import script from "./VirtualReadingForm.vue?vue&type=script&lang=js&"
export * from "./VirtualReadingForm.vue?vue&type=script&lang=js&"
import style0 from "./VirtualReadingForm.vue?vue&type=style&index=0&id=6b7d9a21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d9a21",
  null
  
)

export default component.exports